import React, { useEffect, useState } from "react";
import axios from "axios";
import SectionLandingLikePublications from "../common/SectionLandingLikePublications";

export default function LawsRegulations() {
  const [post, setPost] = useState([]);

  useEffect(() => {
    axios
      .get("/lawsregulations")
      .then((response) => {
        setPost(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        console.error("Failed to load /lawsregulations:", error);
        setPost([]);
      });
  }, []);

  const lead = (
    <>
      <p>
        The National Bank of Rwanda is the supervisor and regulator of financial institutions in Rwanda. The
        promotion, soundness and stability of the sector is attained through implementation of international
        principles and standards as reviewed from time to time by competent bodies such as the International
        Monetary Fund (IMF) and World Bank.
      </p>
      <p>
        The legal and regulatory framework in this section is designed to ensure that financial institutions
        adhere to prudential norms and robust protection of clients and the system. It contains relevant legal
        instruments pertaining to the financial sector in Rwanda.
      </p>
    </>
  );

  return (
    <SectionLandingLikePublications
      breadcrumbCurrent="Laws and Regulations"
      headingId="laws-regulations-bnr-heading"
      pageTitle="Laws and Regulations"
      tagline="Legal instruments for Rwanda’s financial sector"
      sharePageTitle="Laws and Regulations — National Bank of Rwanda"
      lead={lead}
      posts={post}
      pageFeedbackPath="/lawsandregulations"
    />
  );
}
